import EmptyState, {EmptyStateProps} from "./EmptyState";

type Props = EmptyStateProps & { colSpan: number };

export default function EmptyTableRow({ colSpan, ...rest }: Props) {
    return (
        <tr>
            <td colSpan={colSpan} className="p-8">
                <EmptyState {...rest} />
            </td>
        </tr>
    );
}
